import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Block, CheckBox, closeModal, ContainedButton, DefaultText, FlexRow, OutlinedButton, SmallText } from '@guryou/html-components';
import { useOnboardContext } from 'onboard/context';
import OnboardingDateRange from './OnboardingDateRange';

const DEFAULT_START_TIME = '09:00:00';
const DEFAULT_END_TIME = '23:00:00';

const defaultWorkTime = { startTime: DEFAULT_START_TIME, endTime: DEFAULT_END_TIME };

const localSchedules = [
  {
    day: 1,
    workTime: {
      startTime: '2018-01-01T09:00:00',
      endTime: '2038-01-01T23:00:00',
    },
    break: null,
  },
  {
    day: 2,
    workTime: null,
    break: null,
  },
  {
    day: 3,
    workTime: null,
    break: null,
  },
  {
    day: 4,
    workTime: null,
    break: null,
  },
  {
    day: 5,
    workTime: null,
    break: null,
  },
  {
    day: 6,
    workTime: null,
    break: null,
  },
  {
    day: 7,
    workTime: null,
    break: null,
  },
];

const OnboardWorkingHours = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { schedules, setSchedules } = useOnboardContext();
  const [localState, setLocalState] = useState(schedules || localSchedules);

  const handleSetFullWeek = checked => {
    const firstWorkTime = localState[0]?.workTime;
    if (firstWorkTime && checked) {
      const fullSchedule = [1, 2, 3, 4, 5, 6, 7].map(x => ({ day: x, workTime: firstWorkTime, break: null }));

      setLocalState(fullSchedule);
    }
    if (!checked) {
      const fullSchedule = [1, 2, 3, 4, 5, 6, 7].map(x => ({ day: x, workTime: x === 1 ? firstWorkTime : null, break: null }));
      setLocalState(fullSchedule);
    }
  };

  const handleClose = () => {
    dispatch(closeModal('setWorkingHours'));
  };

  const handleSave = () => {
    if (localState?.some(x => x.workTime !== null)) {
      setSchedules(localState);
    }
    dispatch(closeModal('setWorkingHours'));
  };

  return (
    <>
      <FlexRow margin={0} height="60vh" overflowY="auto">
        <Block xs={12}>
          <FlexRow xs={12}>
            <Block xs={4}>
              <DefaultText fontWeight={800}>{t('GENERAL.day')}</DefaultText>
            </Block>
            <Block xs={8} marginLeft={5}>
              <DefaultText fontWeight={800}>{t('GENERAL.workingHours')}</DefaultText>
            </Block>
          </FlexRow>
          {localState.map((x, i) => (
            <React.Fragment key={`day_${x.day}`}>
              <FlexRow alignItems="end" margin={0}>
                <Block lg={4} md={12} xs={12} margin={2}>
                  <CheckBox
                    color="secondary"
                    key={x.workTime}
                    value={x.day}
                    name={`schedules[${x.day - 1}].day`}
                    checked={!!x.workTime}
                    label={t(`GENERAL.days_${x.day}`)}
                    margin="none"
                    number="true"
                    onChange={checked =>
                      setLocalState(localState => {
                        localState[x.day - 1] = checked ? { day: x.day, workTime: defaultWorkTime } : { day: x.day, workTime: null };
                        return [...localState];
                      })
                    }
                  />
                </Block>

                {!!x.workTime && (
                  <>
                    <OnboardingDateRange
                      inline={true}
                      margin={'wizard'}
                      wrapperXs={12}
                      wrapperMd={12}
                      wrapperLg={8}
                      wrapperMargin={0}
                      startTimeFieldName={`schedules[${x.day - 1}].workTime.startTime`}
                      endTimeFieldName={`schedules[${x.day - 1}].workTime.endTime`}
                      startValue={x.workTime.startTime}
                      endValue={x.workTime.endTime}
                      onChange={(startTime, endTime) =>
                        setLocalState(prevState => {
                          prevState[i].workTime = { startTime, endTime };
                          return [...prevState];
                        })
                      }
                      key={`work-${i}`}
                    />
                  </>
                )}
              </FlexRow>
              {localState[0].workTime && i === 0 && (
                <Block xs={12} display="flex" flexDirection="row" justifyContent="center">
                  <Block
                    lg={9}
                    md={12}
                    xs={12}
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    alignItems="center"
                    border="1px solid gray"
                    borderRadius="5px"
                  >
                    <CheckBox
                      color="secondary"
                      xs={11}
                      value={true}
                      checked={false}
                      fullWidth
                      label={
                        <SmallText whiteSpace="normal" wordBreak="break-word" xs={12}>
                          {t('ONBOARD.setSameTime')}
                        </SmallText>
                      }
                      margin="none"
                      number="true"
                      onChange={checked => handleSetFullWeek(checked)}
                    />
                  </Block>
                </Block>
              )}
            </React.Fragment>
          ))}
        </Block>
      </FlexRow>
      <FlexRow xs={12} justifyContent="end">
        <OutlinedButton onClick={handleClose}>{t('ONBOARD.cancel')}</OutlinedButton>
        <ContainedButton onClick={handleSave} color="secondary">
          {t('ONBOARD.save')}
        </ContainedButton>
      </FlexRow>
    </>
  );
};

export default OnboardWorkingHours;
